module.exports = "---\nurl: \"https://petstore.swagger.io/v2/swagger.json\"\ndom_id: \"#swagger-ui\"\nvalidatorUrl: \"https://online.swagger.io/validator\"\noauth2RedirectUrl: \"http://localhost:3200/oauth2-redirect.html\"\n"


//////////////////
// WEBPACK FOOTER
// ./swagger-config.yaml
// module id = 555
// module chunks = 0